import {CoinIcon, CouponIcon, MouseIcon, Panel, QuestionTooltip, Tab, Table, Tag, UsersIcon} from "omoplay";
import {useEffect, useState} from "react";
import {getUserDetail} from "../../api/user/user.api";
import {useSearchParams} from "react-router-dom";
import {getOrdersStatistics} from "../../api/statistics/statistics.api";
import InputGroup from "../form/InputGroup";
import {basicBarOption} from "../../constants/chart_config";
import EChartsReact from "echarts-for-react";
import ProjectCalendarSearchBar from "../ProjectCalendarSearchBar";
import {
    UserCircleIcon,
    DevicePhoneMobileIcon,
    EnvelopeIcon,
    MapPinIcon,
    CalendarDaysIcon,
    ArrowRightStartOnRectangleIcon,
    UserPlusIcon,
    BellAlertIcon,
} from '@heroicons/react/24/outline';

const UserDetail = () => {
    const [query] = useSearchParams()
    const [tab, setTab] = useState("init")
    const [user, setUser] = useState({})
    const [orderTotalCount, setOrderTotalCount] = useState(0)
    const [orderTotalSales, setOrderTotalSales] = useState(0)
    const [orderTables, setOrderTables] = useState([])
    const [orders, setOrders] = useState([])
    const [orderCharts, setOrderCharts] = useState({})
    const [orderDate, setOrderDate] = useState({})
    // 자사몰 주문 조회(statistics-parsing-service)가 실패했을 때의 사유.
    // 🔴 실패를 '0원' 으로 보여주면 장애가 '구매 없음' 으로 읽힌다(2026-09-11, D-8).
    const [orderError, setOrderError] = useState("")
    const [journeys, setJourneys] = useState([])
    const [preference, setPreference] = useState("")

    const tabHeaders = [
        {label: "개요", value: "init", selected: true}, {label: "구매 이력", value: "sales"},
        {label: "고객 여정", value: "journey"}/*, {label: "고객 취향", value: "preference"}*/
    ]

    const orderHeaders = [
        { name: "상품명", align: "center" },
        { name: "채널", align: "center", width: "150px" },
        { name: "주문 상태", align: "center", width: "150px" },
        { name: "결제 가격", align: "center", width: "150px" },
        { name: "결제 날짜", align: "center", width: "180px" },
    ];

    const journeyHeaders = [
        { name: "액션", align: "center", width: "150px" },
        { name: "타입", align: "center", width: "180px" },
        { name: "내용", align: "center" },
        { name: "금액", align: "center", width: "150px" },
        { name: "일시", align: "center", width: "190px" }
    ];

    useEffect(() => {
        const userId = query.get("id")
        getUserDetail(userId).then(({data}) => {
            if (!data) {
                alert("고객 정보가 없습니다.")
                window.location.href = "/users"
            }
            setUser(data)
            setJourneys(data.journeyList?.map(journey => {
                const type = journey.type
                let typeColor = ""
                if (type === "구매") {
                    typeColor = "info"
                } else if (type === "장바구니") {
                    typeColor = "success"
                } else if (type === "이벤트") {
                    typeColor = "warning"
                } else if (type === "메시지") {
                    typeColor = "#fbe300"
                } else if (type === "메시지 클릭") {
                    typeColor = "#1bc87a"
                } else if (type === "메시지 혜택") {
                    typeColor = "#fd9bdf"
                } else if (type === "카카오 친구 상태") {
                    typeColor = "error"
                }
                return [
                    <div className="flex-center-all h-full">
                        <Tag color={typeColor}>{journey.type}</Tag>
                    </div>,
                    <div className="flex-center-all h-full"><Tag>{journey.entryPoint}</Tag></div>,
                    <div className="flex items-center gap-2 whitespace-pre h-full">
                        <div>
                            {
                                journey.products?.map(({imgUrl, code, name}) => {
                                    if (!imgUrl) {
                                        return <div className="ml-[72px]">{name}</div>
                                    }
                                    return (
                                        <div className="flex-align-center gap-2">
                                            <img src={imgUrl} className="w-16 h-16" />
                                            <div className="text-primary pointer" onClick={() => productDetail(code) }>{name}</div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                        {
                            journey.imgUrl ? <img src={journey.imgUrl} alt="journey" className="w-16 h-16" /> : <></>
                        }
                        <div>{journey.content}</div>
                    </div>,
                    <div className="flex-center-all h-full text-center whitespace-pre">{journey.price != null ? `${journey.price}` : ""}</div>,
                    <div className="flex-center-all h-full">{journey.createdAt}</div>
                ]
            }, []))
        })
        /*
        getPreference(userId).then(({data}) => {
            setPreference(data)
        })
        */
    }, [query]);

    useEffect(() => {
        const userId = query.get("id")
        setOrderError("")
        getOrdersStatistics(userId, orderDate?.startDate, orderDate?.endDate).then(({data}) => {
            if (data) {
                if (!orderDate?.startDate) {
                    setOrderTotalCount(data.totalCount ?? 0)
                    setOrderTotalSales(data.totalSales ?? 0)
                }
                setOrders(data)
                setOrderTables(data.users?.map(user => {
                    return [
                        <div className="flex-col h-full">
                            {
                                user.products?.map(({imgUrl, code, name}) => {
                                    if (!imgUrl) {
                                        return <div className="ml-[72px]">{name}</div>
                                    }
                                    return (
                                        <div className="flex-align-center gap-2">
                                            <img src={imgUrl} className="w-16 h-16" />
                                            <div className="text-primary pointer" onClick={() => productDetail(code) }>{name}</div>
                                        </div>
                                    )
                                })
                            }
                        </div>,
                        <div className="flex-center-all h-full">{user.channel ?? "자사몰(온라인)"}</div>,
                        <div className="flex-center-all h-full">{user.productStatus}</div>,
                        <div className="flex-center-all h-full">{user.paymentAmount.toLocaleString()}</div>,
                        <div className="flex-center-all h-full">{user.paymentDate}</div>,
                    ]
                }, []))
                const orderUsers = data.users?.sort((a, b) => new Date(a.paymentDate) - new Date(b.paymentDate)) ?? []
                const orderXAxis = orderUsers.map(user => user.paymentDate)
                const orderYAxis = orderUsers.map(user => user.paymentAmount)
                setOrderCharts({xAxis: orderXAxis, yAxis: orderYAxis})
            }
        }).catch((e) => {
            // 🔴 catch 가 없으면 처리되지 않은 rejection 이 된다 — fetch.js 의 503 분기가 reject 로
            //    돌려주기 때문이다(같은 변경에서 함께 넣어야 하는 짝, 2026-09-11 D-8).
            setOrderTotalCount(0)
            setOrderTotalSales(0)
            setOrderTables([])
            setOrders([])
            setOrderCharts({})
            setOrderError(e?.message || "구매 이력을 불러오지 못했습니다.")
        })
    }, [query, orderDate]);

    function productDetail(productCode) {
        window.open(`/product/detail?productCode=${productCode}`)
    }

    const InfoRow = ({ icon, label, value }) => (
        <div className="flex items-start py-3 gap-2">
            <div className="flex-shrink-0 w-8 pt-1 text-gray-500">{icon}</div>
            <div className="flex-1">
                <p className="text-sm font-medium text-gray-500">{label}</p>
                <p className="text-base text-gray-800">{value}</p>
            </div>
        </div>
    );

    return (
      <div className="flex-col gap-4">
          <div className="flex items-center p-6 bg-gray-50">
              <img
                  src={user.profileImageUrl}
                  alt="프로필 이미지"
                  className="w-20 h-20 object-cover rounded-full border-2 border-white shadow-md"
              />
              <div className="ml-5">
                  <h2 className="text-2xl font-bold text-gray-800">{user.name}</h2>
                  <p className="text-md text-gray-500">{user.nickname}</p>
              </div>
          </div>
            <div className="flex-col bg-white">
              <Panel items={[
                {
                  title: (
                      <>
                        <div className='panel-icon'>
                          <UsersIcon />
                        </div>
                        <p>구매 이력</p>
                      </>
                  ),
                  value: orderError ? "-" : orderTotalSales?.toLocaleString(),
                  suffix: orderError ? "집계 불가" : `원 (${orderTotalCount}회)`,
                },
                {
                  title: (
                      <>
                        <div className='panel-icon'>
                          <MouseIcon />
                        </div>
                        <p>도달 클래스</p>
                      </>
                  ),
                  value: user.dataClass,
                  suffix: `(친구상태,SMS,Email,브랜드톡)`,
                },
                {
                  title: (
                      <>
                        <div className='panel-icon'>
                          <CouponIcon />
                        </div>
                        <p>등급 / 상태</p>
                      </>
                  ),
                  value: "일반",
                  suffix: ``,
                },
                {
                  title: (
                      <>
                          <div className='panel-icon'>
                          <CoinIcon />
                          </div>
                          <p>CLV</p>
                          <div>
                              <QuestionTooltip>
                                  3년간 구매할 것으로 예상 되는 가치
                              </QuestionTooltip>
                          </div>
                      </>
                  ),
                  value: user.clv?.toLocaleString(),
                  suffix: `원 (3년)`,
                }
              ]} />
            </div>
            <Tab items={tabHeaders}
                 onChanged={(item) => {
                   setTab(item.value)
                 }}
            />
          {
              tab === "init" && (
                  <>
                      <div className="w-full max-w-2xl bg-white rounded-xl shadow-lg overflow-hidden">
                          <div className="p-6">
                              <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8">
                                  <div>
                                      <h3 className="text-lg font-semibold text-gray-700 mb-2">개인 정보</h3>
                                      <InfoRow icon={<UserCircleIcon />} label="성별 / 생년월일 / 나이" value={`${user.gender} / ${user.birthDay} / ${user.age}`} />
                                      <InfoRow icon={<DevicePhoneMobileIcon />} label="휴대폰 번호" value={user.phoneNumber} />
                                      <InfoRow icon={<EnvelopeIcon />} label="이메일" value={user.email} />
                                      <InfoRow icon={<MapPinIcon />} label="주소" value={user.address} />
                                  </div>
                                  <div>
                                      <h3 className="text-lg font-semibold text-gray-700 mb-2 mt-6 md:mt-0">계정 정보</h3>
                                      <InfoRow icon={<CalendarDaysIcon />} label="가입일" value={user.createdAt} />
                                      <InfoRow icon={<ArrowRightStartOnRectangleIcon />} label="진입점" value={user.entryPoint} />
                                      <InfoRow icon={<UserPlusIcon />} label="카카오 채널 친구" value={`${user.friendStatus} (${user.modifiedFriendsAt})`} />
                                      <InfoRow icon={<BellAlertIcon />} label="마케팅 수신 동의" value={`SMS: ${user.smsAgreed ? '동의' : '비동의'} / Email: ${user.emailAgreed ? '동의' : '비동의'}`} />
                                  </div>
                              </div>
                          </div>
                      </div>
                  </>
              )
          }
          {
              tab === "sales" && (
                  <InputGroup label="구매 이력" description="기간별로 구매이력을 확인할 수 있습니다.">
                      <div className="flex-col gap-4">
                          <ProjectCalendarSearchBar
                              initDateType="all"
                              onConfirm={(dateProps) => setOrderDate(dateProps)} />
                          <div className="w-full">
                              <Panel variants="bar" items={[
                                  {
                                      title: "총 구매액", titleStyle: {backgroundColor: "unset"},
                                      value: <div className="text-primary">{orders.totalSales?.toLocaleString()}원</div>,
                                      style: { flex: "1", border: "1px solid #e5e7eb"}
                                  },
                                  {
                                      title: "총 구매 횟수", titleStyle: {backgroundColor: "unset"},
                                      value: <div className="text-primary">{orders.totalCount?.toLocaleString()}회</div>,
                                      style: { flex: "1", border: "1px solid #e5e7eb"}
                                  },
                                  {
                                      title: "평균 구매액", titleStyle: {backgroundColor: "unset"},
                                      value: <div className="text-primary">{orders.avgPrice?.toLocaleString()}원</div>,
                                      style: { flex: "1", border: "1px solid #e5e7eb"}
                                  },
                                  {
                                      title: "평균 구매 주기", titleStyle: {backgroundColor: "unset"},
                                      value: <div className="text-primary">{orders.periodSales?.toLocaleString()}일</div>,
                                      style: { flex: "1", border: "1px solid #e5e7eb"}
                                  }
                              ]} />
                          </div>
                          {
                              orderError && (
                                  <div className="w-full flex flex-col items-center justify-center gap-2 py-10">
                                      <div className="text-sm font-semibold text-gray-700">구매 이력을 지금은 불러올 수 없습니다.</div>
                                      <div className="text-xs text-gray-500 text-center px-4 break-words">{orderError}</div>
                                      <div className="text-xs text-gray-400">잠시 후 다시 시도해 주세요.</div>
                                  </div>
                              )
                          }
                          <EChartsReact option={basicBarOption(orderCharts.xAxis, orderCharts.yAxis, "원")} />
                          <Table headers={orderHeaders} data={orderTables} />
                      </div>
                  </InputGroup>
              )
          }
          {
              tab === "journey" && (
                  <InputGroup label="고객 여정" description="고객의 구매, 방문, 인게이지먼트와 같은 정보를 시계열로 순서대로 확인할 수 있습니다.">
                      <Table headers={journeyHeaders} data={journeys}
                             pagination={{pageSize: 10, totalCount: journeys.length, currentPage: 1}}
                      />
                  </InputGroup>
              )
          }
          {/*
              tab === "preference" && (
                  <div className="flex-col gap-4">
                      <InputGroup label="AI 추천 상품 목록" description="해당 고객의 맞춤 추천 상품입니다.">
                          <div className="flex gap-2 h-full">
                              {
                                  preference?.productCodes?.map(({code, name}) => {
                                      return (
                                          <div className="pointer" onClick={() => productDetail(code) }>
                                              <Tag color="primary">{name}</Tag>
                                          </div>
                                      )
                                  })
                              }
                          </div>
                      </InputGroup>
                      <InputGroup label="고객 취향" description="고객의 구매 패턴을 AI가 분석해 취향을 확인 합니다.">
                          <div className="whitespace-pre-line">
                              <ReactMarkdown>{preference?.text}</ReactMarkdown>
                          </div>
                      </InputGroup>
                  </div>
              )
          */}
      </div>
    );
};
export default UserDetail;
